import React, { Component, Fragment } from 'react';
import { Image } from 'react-bootstrap';
import { Button, Col, Container, Row } from 'reactstrap';
import LoggedContext from '../BusinessObjects/LoggedContext';
import EsaedroResourceAttachment from '../Models/EsaedroResourceAttachment';
import { themeBackButton, themeCol3, themeCol9, themeFormInput, themeGroup } from '../Utils/EsaedroTheme';

interface IEsaedroAttachmentProps {
    attachment: string,
    attachmentFieldName: string,
    name: string,
    canLoad: boolean,
    canDelete: boolean,
    resourceAttachment?: EsaedroResourceAttachment,
    onChange?(event: any) : void
    onDelete?(resourceAttachment: EsaedroResourceAttachment) : void
}

export default class EsaedroAttachment extends Component<IEsaedroAttachmentProps> {

  static contextType = LoggedContext
  context!: React.ContextType<typeof LoggedContext>
  
  constructor(props: IEsaedroAttachmentProps){
    super(props);

    this.state = {
      uploading: false
    };
  }

  removeImage = () => {
    // Controllo se è impostato l'handler per la delete e se il componente è associato ad un ResourceAttachment 
    if (this.props.onDelete && this.props.resourceAttachment) {
      this.props.onDelete(this.props.resourceAttachment)
    }
    else {
      // Altrimenti ritorna un evento custom alla callback onChange (Utilizzato dalla ObjectEdit)
      let customEvent = new CustomEvent("DeleteFile", {detail: this.props.name})
      if (this.props.onChange) this.props.onChange(customEvent)
    }
  } 
  
  render() {
    const {attachment, attachmentFieldName, name} = this.props

    var description = this.props.resourceAttachment? 
                        this.props.resourceAttachment.Description 
                      : attachmentFieldName

    var deleteButton = this.props.canDelete? <Button 
                                                className={themeBackButton()} 
                                                onClick={() => this.removeImage()} 
                                              >
                                                   <i className="fa fa-close"> </i> Elimina
                                              </Button>
                                            : undefined

    var newFileButton = this.props.canLoad?  <input type='file' onChange={this.props.onChange} name={name}/>
                                            : <span>Non è possibile aggiungere allegati per questa risorsa</span>

    if (attachment != undefined && attachment != "")
      return (
        // TODO Controllare il tipo di attachment prima di renderizzare Images
        <Row className={themeGroup()}>
          <Col className={themeCol3()}>
            <label htmlFor={name}>{description}</label>  
          </Col>
          <Col className={themeCol9()}>
            <Image src={attachment} alt={description} thumbnail height={50} width={50}></Image>
            {deleteButton}
          </Col>
        </Row> 
      )

    else 
      return newFileButton
  }
}